<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      no-local-sorting
      sort-icon-left
    >
      <template
        v-if="listFilters"
        #top-row="data"
      >
        <td
          v-for="(field,key) in data.fields"
          :key="key"
        >
          <list-column-filter
            v-if="field.key !=='action'"
            :name="field.key"
            :label="field.label"
            :filter="listFilters[field.key]"
            :value="filters[field.key]"
            @onFilterChange="( name, value)=> $emit('onFilterChange', name, value)"
          />
          <b-button
            v-else
            block
            variant="success"
            @click="$emit('onFilterButtonClicked')"
          >
            {{ $t("Search") }}
          </b-button>
        </td>
      </template>
      <!-- A custom formatted count column -->
      <template #cell(count)="data">
        {{ data.value | numberFormat }}
      </template>
      <!-- A custom formatted total_amount column -->
      <template #cell(total_amount)="data">
        <display-currency :value="data.value" />
      </template>
      <!-- A custom formatted total_commission column -->
      <template #cell(total_commission)="data">
        <display-currency :value="data.value" />
      </template>
      <!-- A custom formatted created_at column -->
      <template #cell(created_at)="data">
        <display-date-time :value="data.value" />
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no users to display") }}
      </h6>
    </div>
  </div>
</template>

<script>
import { ListTable } from '../../../common/mixins/list'

export default {
  name: 'AffiliateUsersList',
  mixins: [ListTable],
  data() {
    return {
      routeName: 'affiliate-users',
    }
  },
}
</script>

<style scoped>

</style>
